// src/authProvider.js
import { getAuth, signInWithEmailAndPassword, signOut } from "firebase/auth";
import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyCqfprIuIUWv3AEMTnH2DLsktfvVvhVH2Y",
  authDomain: "pondlifeapp.firebaseapp.com",
  projectId: "pondlifeapp",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

const authProvider = {
  login: async ({ username, password }) => {
    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        username,
        password
      );
      localStorage.setItem("uid", userCredential.user.uid);
      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error);
    }
  },
  logout: async () => {
    await signOut(auth);
    localStorage.removeItem("uid");
    return Promise.resolve();
  },
  checkAuth: () =>
    localStorage.getItem("uid") ? Promise.resolve() : Promise.reject(),
  checkError: () => Promise.resolve(),
  getPermissions: () => Promise.resolve(),
};

export default authProvider;
